type UserFilters = Record<string, unknown> & {
  phone_number?: Record<string, unknown> & { contains?: string };
};

/** Keep the displayed filter intact; send only standard filters to the API. */
export function normalizePhoneSearch(where: UserFilters): UserFilters {
  if (typeof where.phone_number?.contains !== 'string') return where;

  const { contains, ...phoneFilters } = where.phone_number;
  const normalized = { ...where };

  if (contains !== '') {
    const digits = contains.replace(/[\s().+-]/g, '');
    if (/^\d+$/.test(digits)) {
      phoneFilters.contains = digits;
    } else {
      // An empty IN filter matches nothing; an empty contains would match all.
      phoneFilters.in = [];
    }
  }

  if (Object.keys(phoneFilters).length) {
    normalized.phone_number = phoneFilters;
  } else {
    delete normalized.phone_number;
  }

  return normalized;
}
